var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerLoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#B8B8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5872 19.0213C13.5872 19.0213 13.0804 19.717 13.8655 19.717H16.9565L16.1614 25.3125C16.1179 25.4443 16.1285 25.588 16.1909 25.7119C16.2534 25.8359 16.3625 25.9299 16.4943 25.9734C16.6261 26.0169 16.7698 26.0063 16.8937 25.9438C17.0177 25.8814 17.1117 25.7723 17.1552 25.6405L20.2462 20.2338L15.5452 15.5825L13.5872 19.0213Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1843 16.7682C22.3731 16.3508 22.1843 16.1819 21.8265 16.1819H18.7256L19.5207 10.5864C19.5322 10.5143 19.5279 10.4406 19.5083 10.3703C19.4886 10.3 19.454 10.2348 19.4068 10.1792C19.3597 10.1235 19.301 10.0786 19.2349 10.0477C19.1688 10.0168 19.0968 10.0005 19.0238 10C18.9331 10.0001 18.8441 10.024 18.7656 10.0693C18.6871 10.1147 18.6219 10.1799 18.5766 10.2584L16.3105 14.2339L20.9619 18.9448L22.1843 16.7682Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0626 25.7339C23.9646 25.7349 23.8674 25.7161 23.7768 25.6785C23.6863 25.6409 23.6043 25.5854 23.5358 25.5152L10.218 12.2073C10.0784 12.0676 10 11.8781 10 11.6806C10 11.4831 10.0784 11.2936 10.218 11.1538C10.2865 11.0835 10.3684 11.0276 10.4589 10.9895C10.5494 10.9513 10.6466 10.9316 10.7447 10.9316C10.8429 10.9316 10.9401 10.9513 11.0306 10.9895C11.1211 11.0276 11.203 11.0835 11.2715 11.1538L24.5893 24.4617C24.7289 24.6015 24.8073 24.791 24.8073 24.9885C24.8073 25.186 24.7289 25.3755 24.5893 25.5152C24.5205 25.5849 24.4385 25.6402 24.348 25.6777C24.2576 25.7153 24.1605 25.7344 24.0626 25.7339V25.7339Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerLoss);
export default __webpack_public_path__ + "static/media/PowerLoss.ed06e88c88ad091100c51ae470e64c62.svg";
export { ForwardRef as ReactComponent };